module.exports = __webpack_public_path__ + "media/assets/gray-f09c3488a0e3a84624a4c83b81bbf270.png";